var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-top",class:{ 'back-top--active': _vm.show },on:{"click":_vm.backTop}},[_c('div',{staticClass:"back-top--btn"})])}
var staticRenderFns = []

export { render, staticRenderFns }